import * as React from 'react';
import type {MenuItemType} from './MenuItem';
import type {MenuTriggerType} from './MenuTrigger';

type ChildType = { type: any} & (MenuItemType | MenuTriggerType);

export function extractMenuElements(children: any, triggerRef: any) {
  let triggerElement: MenuTriggerType | null = null;
  let menuItems: MenuItemType[] = [];
  React.Children.map(children, (child: ChildType) => {
    if (React.isValidElement(child)) {
      if (child['type']?.['role'] === "menu-trigger") {
        triggerElement = React.cloneElement(child as any, { ref: triggerRef }) as any;
        return triggerElement;
      }
    }
    if (child['type']?.['role'] === "menu-item") {
      menuItems.push(child as MenuItemType);
    }
    return child;
  });

  return { triggerElement, menuItems };
}